module.exports = __webpack_public_path__ + "media/customizations/lakenona/back-c2ea547396f7ed45d7081f54ba2d1084.jpg";